module.exports = __webpack_public_path__ + "static/img/001_TO8_1498.1db02e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/001_TO8_1498.jpg
// module id = BGrJ
// module chunks = 0